module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-BE":{"short_lang":"NL","logout":"Afmelden","login":"Log in"},"en-BE":{"short_lang":"EN","logout":"Logout","login":"Log in"},"fr-BE":{"short_lang":"FR","logout":"Déconnexion","login":"S\u0027identifier"}}')
  delete Component.options._Ctor
}
